import script from "./ComexPipelineStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./ComexPipelineStatus.vue?vue&type=script&setup=true&lang=js"

import "./ComexPipelineStatus.vue?vue&type=style&index=0&id=1d7fb00a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d7fb00a"]])

export default __exports__